import type { TeamUsage } from "schemas/generated/bedrock";
import type { RequestFn } from "./request";

export function createTeamUsageClient({ request }: { request: RequestFn }) {
  return {
    get: ({
      projectId,
      windowDays,
    }: {
      projectId: string;
      windowDays?: number;
    }) => {
      return request<TeamUsage>({
        method: "GET",
        path: `/api/v1/projects/${encodeURIComponent(projectId)}/team-usage`,
        query: { windowDays },
      });
    },
  };
}
